"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.transitionOutHandler = exports.transitionInHandler = void 0;
var store_1 = require("./store");
var route_1 = require("./actions/route");
/**
 * This utility takes the supplied argument `view` and attempts to match it against the `view` property in either the
 * `enter` or `exit` objects in the route metadata, then returns that information to the caller.
 *
 * @function determineRouteMeta
 * @param {string} view - Represents the value of the `view` property on the `route` object for which you are interested
 * @param {Object} route - Route metadata found in the store
 * @returns {{params: {}, query: {}, isFlow, flow}}
 */
function determineRouteMeta(view, route) {
    var params = {}, query = {}, isFlow = !!route.isFlow, flow;
    if (!route) {
        return { params: params, query: query, isFlow: isFlow, flow: "" };
    }
    // prioritize the `enter` object
    if (route.enter.view === view) {
        params = route.enter.params;
        query = route.enter.query;
        flow = route.enter.flow;
        // if no match found, try `exit`
    }
    else if (route.exit && route.exit.view === view) {
        params = route.exit.params;
        query = route.exit.query;
        flow = route.exit.flow;
    }
    return {
        params: params,
        query: query,
        isFlow: isFlow,
        flow: flow,
    };
}
exports.default = determineRouteMeta;
function transitionInHandler() {
    store_1.store.dispatch(route_1.transitionIn());
}
exports.transitionInHandler = transitionInHandler;
function transitionOutHandler() {
    store_1.store.dispatch(route_1.transitionOut());
}
exports.transitionOutHandler = transitionOutHandler;
